import getClientInformations from './getClientInformations';
import getSellerPartners from './getSellerPartners';

export const ClientService = {
  getClientInformations,
  getSellerPartners,
};
